import React, { useEffect, useMemo, useState } from "react";
import ListboxSimple from "@components/tailwindComponents/ListboxSimple";
import { Bar } from "react-chartjs-2";
import ModalGraph from "@image/icones/DocumentsEmployers/graph.svg";
import Next from "@image/icones/DocumentsEmployers/next.svg";
import ModalIndex from "@Modals/layout/index";
import moment from "moment";

const options = (stepSize) => {
  return {
    legend: {
      display: false,
      maintainAspectRatio: false
    },
    scales: {
      yAxes: [
        {
          ticks: {
            min: 0,
            stepSize
          }
        }
      ],
    },
    plugins: {
      legend: {
        display: false
      },
      interaction: {
        intersect: false
      }
    }
  };
};

function TemporalStatistics({ text, backgroundColor, borderColor, datas = [], yearTitle, translate }) {
  const [listYears, setListYears] = useState([]);
  const [selectedYear, setSelectedYear] = useState({});
  const [datasYear, setDatasYear] = useState([]);

  const labels = useMemo(() => {
    return ([
      translate("Jan"),
      translate("Fev"),
      translate("Mar"),
      translate("Avr"),
      translate("Mai"),
      translate("Juin"),
      translate("Juil"),
      translate("Aug"),
      translate("Sep"),
      translate("Oct"),
      translate("Nov"),
      translate("Déc")
    ]);
  }, [translate])

  const data = (backgroundColor, borderColor, data) => {
    return {
      labels,
      datasets: [
        {
          data: data?.length ? data : [],
          backgroundColor: backgroundColor,
          borderColor: borderColor,
          borderWidth: 1
        }
      ]
    };
  };

  const stepSize = useMemo(() => {
    const maxValueCount = datas.reduce((max, item) => item.count > max ? item.count : max, 0);
    return Math.floor(maxValueCount / 5) + 1;
  }, [datas]);

  const getDataYear = (year) => {
    let monthsOfYear = datas.filter(
      (item) => item.year.toString() === year.toString()
    );
    let max = 0;
    monthsOfYear.sort((a, b) => a.year - b.year);

    // Créer un tableau avec tous les mois de janvier à février
    const months = [];
    for (let month = 1; month <= 12; month++) {
      months.push(0);
    }

    // Parcourir les données d'origine et mettre à jour les valeurs correspondantes
    monthsOfYear.forEach((item) => {
      if (item.count) {
        months[item.month - 1] = item.count;
        if (item.count > max) {
          max = item.count;
        }
      }
    });
    // max = (Math.trunc(max / 10) + 1) * 10;
    // setMaxYear(max);
    return months;
  };

  useEffect(() => {
    if (datas?.length) {
      let uniqueYears = datas.reduce((years, item) => {
        const foundYear = years.find((year) => year._id === item.year);
        if (!foundYear) {
          years.push({
            _id: item.year,
            title: item.year.toString()
          });
        }
        return years;
      }, []);
      uniqueYears.sort((a, b) => a._id - b._id);
      const selectYear = uniqueYears[uniqueYears.length - 1];
      let monthsOfYear = getDataYear(selectYear.title);
      setDatasYear(monthsOfYear);
      setSelectedYear(selectYear);
      setListYears(uniqueYears);
    }
    // eslint-disable-next-line
  }, [datas]);

  const handleSelectedYear = (value) => {
    setSelectedYear(value);
    setDatasYear(getDataYear(value.title));
  };

  const [showModal, setShowModal] = useState(false);

  const handleShowModal = () => {
    setShowModal(!showModal);
  };

  const handleClickPrevious = () => {
    const foundIndex = listYears.findIndex(item => item._id === selectedYear?._id);
    let prevIndex = 0;
    if (foundIndex > 0) {
      prevIndex = foundIndex - 1;
    } else {
      prevIndex = listYears.length - 1;
    }
    setSelectedYear(listYears[prevIndex]);
    setDatasYear(getDataYear(listYears[prevIndex].title));
  }

  const handleClickNext = () => {
    const foundIndex = listYears.findIndex(item => item._id === selectedYear?._id);
    let prevIndex = 0;
    if (foundIndex < listYears.length - 1) {
      prevIndex = foundIndex + 1;
    } else {
      prevIndex = 0;
    }
    setSelectedYear(listYears[prevIndex]);
    setDatasYear(getDataYear(listYears[prevIndex].title));
  }

  return (
    <>
      <div className="arh-w-full arh-h-full">
        <div className="arh-flex arh-flex-col arh-w-full arh-h-full arh-mb-18 arh-p-18 arh-border arh-border-solid arh-border-borderStat">
          <div className="arh-w-full arh-flex arh-justify-between arh-items-center">
            <h3 className="arh-w-36 arh-m-0 arh-font-poppins arh-font-bold arh-text-15 arh-text-black">
              {text}
            </h3>
            <button
              className="arh-border-0 arh-bg-transparent" 
              onClick={handleShowModal}
            >
              <img alt="graph" src={ModalGraph} />
            </button>
          </div>
          <div className="arh-flex arh-justify-between">
            <div className="arh-w-fit arh-mt-12">
              <div className="arh-flex arh-items-center arh-font-poppins arh-font-medium arh-text-xs arh-mb-2">
                <div className="arh-w-[14px] arh-h-[14px] arh-bg-blue-500 arh-mr-1">
                </div>
                Date
              </div>
              <div className="arh-w-28">
                <ListboxSimple
                  labelActive
                  label={yearTitle}
                  placeholder={moment().format("YYYY")}
                  noRadio
                  optionList={listYears}
                  optionTextAttribut="title"
                  selectedValue={selectedYear}
                  setSelectedValue={handleSelectedYear}
                  noOpen={listYears.length < 2}
                />
              </div>
            </div>
            <div className="arh-flex arh-justify-center arh-items-center arh-w-3/4">
              {
                Boolean(listYears.length > 1) &&
                <img
                  alt="previous"
                  className="arh-mx-2 arh-my-0 arh-rotate-180 arh-cursor-pointer arh-mb-[1.3rem]"
                  src={Next}
                  onClick={handleClickPrevious}
                />
              }

              <div className="arh-w-[30rem]">
                <Bar
                  data={data(backgroundColor, borderColor, datasYear)}
                  options={options(stepSize)}
                //   width={100}
                // // height={150}
                />
              </div>
              {
                Boolean(listYears.length > 1) &&
                <img
                  alt="next"
                  className="arh-mx-2 arh-my-0 arh-cursor-pointer arh-mb-[1.3rem]"
                  src={Next}
                  onClick={handleClickNext}
                />
              }
            </div>
          </div>
        </div>
      </div>


      <ModalIndex
        isOpen={showModal}
        onClickClose={handleShowModal}
        title={text}
        widthType="extra-large"
        buttonType="none"
      >
        <div className="arh-flex arh-w-full ">
          <div className="arh-flex arh-flex-1 arh-items-start arh-justify-center">
            <div className="arh-flex arh-justify-between arh-items-center arh-w-3/4">
              {
                Boolean(listYears.length > 1) &&
                <img
                  alt="previous"
                  className="arh-mx-2 arh-my-0 arh-rotate-180 arh-cursor-pointer arh-mb-[1.3rem]"
                  src={Next}
                  onClick={handleClickPrevious}
                />
              }
              <Bar
                data={data(backgroundColor, borderColor, datasYear)}
                options={options(stepSize)}
              />
              {
                Boolean(listYears.length > 1) &&
                <img
                  alt="next"
                  className="arh-mx-2 arh-my-0 arh-cursor-pointer arh-mb-[1.3rem]"
                  src={Next}
                  onClick={handleClickNext}
                />
              }
            </div>
          </div>
        </div>
      </ModalIndex>
    </>
  );
}

export default React.memo(TemporalStatistics);
